/**
 *
 * @param durationMs
 * @returns Promise
 */
export const sleep = (durationMs: number) =>
  new Promise(resolve => setTimeout(resolve, durationMs));

export const promiseNoop = async () => {
  await sleep(700);
};
